var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center h-100-vh d-flex align-items-center justify-content-center bg-white"},[_c('b-spinner',{staticClass:"m-5 spinner-main",attrs:{"label":"Loading...","variant":_vm.variant}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }